<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1090_129)">
      <path d="M21 4H4V16H21V4Z" fill="white" />
      <path d="M9 8H7V10H9V8Z" fill="#3CB149" />
      <path d="M13 8H11V10H13V8Z" fill="#3CB149" />
      <path d="M17 8H15V10H17V8Z" fill="#3CB149" />
      <path
        d="M20 19.0001H4C3.46957 19.0001 2.96101 18.7893 2.58594 18.4142C2.21086 18.0391 2 17.5306 2 17.0001V5.00013C2.00315 4.47067 2.21545 3.96339 2.58984 3.589C2.96424 3.21461 3.47054 3.00328 4 3.00013H20C20.2633 2.99708 20.5245 3.0473 20.7676 3.14857C21.0107 3.24984 21.2308 3.3999 21.4141 3.589C21.6042 3.77148 21.7543 3.99118 21.8555 4.23451C21.9567 4.47783 22.0066 4.73958 22.002 5.00306V17.0031C22.002 17.5335 21.7911 18.0421 21.416 18.4171C21.0409 18.7922 20.5324 19.0031 20.002 19.0031L20 19.0001ZM4 5.00013V14.0001H20V5.00013H4Z"
        fill="#D5D8DC"
      />
      <path d="M16 22H8V21L10 19H14L16 21V22Z" fill="#363C43" />
    </g>
    <defs>
      <clipPath id="clip0_1090_129">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
